import { html, View } from 'rune-ts';
import quickMenuClass from './QuickMenu.module.scss';
import { dataStr } from '../../../../shared/util/dataStr';
import { font } from '@services/MarppleShop/shared/typography';
import { MpsScrollSync } from '@services/MarppleShop/shared/components/cells/MpsScrollSync/mps-scroll-sync.ts';

export interface QuickMenuData {
  title: string;
  icon: string;
  navigate?: object;
  href: string;
  target: '_self' | '_blank';
  is_apply?: boolean;
  no_pc: [number, number];
  no_mo: [number, number];
}

export type QuickMenuViewOptions = {
  size: 'medium' | 'small';
  use_scroll_snap?: boolean;
};

class QuickMenuView extends View<QuickMenuData> {
  constructor(
    data: QuickMenuData,
    public option: QuickMenuViewOptions,
  ) {
    super(data, option);
  }

  public static readonly SizeOptions = {
    medium: quickMenuClass.medium,
    small: quickMenuClass.small,
  };

  private get fontSize(): string {
    switch (this.option.size) {
      case 'medium':
        return font('16_medium');
      case 'small':
        return font('14_medium');
    }
  }

  private get scrollSnap(): string {
    return this.option.use_scroll_snap ? quickMenuClass.scroll_snap : '';
  }

  protected override template() {
    const { href, target, icon, title, navigate, is_apply } = this.data;

    return html`
      <a
        class="${quickMenuClass.quick_menu} ${is_apply ? quickMenuClass.apply : ''} ${this.scrollSnap}"
        ${navigate ? html`data-post-message="${dataStr(navigate)}"` : ''}
        href="${html.preventEscape(href)}"
        target="${target}"
      >
        <div class="${quickMenuClass.icon}">
          <img src="${icon}" alt="" />
        </div>
        <div class="${quickMenuClass.title} ${this.fontSize}">${title}</div>
      </a>
    `;
  }
}

export type QuickMenuListViewOptions = {
  size: 'medium' | 'small';
  use_scroll_snap?: boolean;
};

export class QuickMenuListView extends View<[QuickMenuData[], QuickMenuData[]]> {
  constructor(
    data: [QuickMenuData[], QuickMenuData[]],
    public option: QuickMenuListViewOptions,
  ) {
    super(data, option);
  }

  protected override template() {
    const floors_html = this.data.map((list) => {
      return html`
        <div class="${quickMenuClass.quick_menu_floor}">
          ${list.map((menu) => new QuickMenuView(menu, this.option))}
        </div>
      `;
    });
    if (this.option.use_scroll_snap) {
      return html`
        <div>
          ${new MpsScrollSync({
            lists: floors_html,
            style: {
              list: quickMenuClass.quick_menu_list,
            },
            preset: 'middle',
          })}
        </div>
      `;
    }
    return html` <div class="${quickMenuClass.quick_menu_list}">${floors_html}</div> `;
  }

  public static readonly SizeOptions = {
    medium: quickMenuClass.medium,
    small: quickMenuClass.small,
  };
}
